<script>
// Mixins
import styles from '../mixins/styles.js';

// Types
import { 
    formElementVariants, 
    defaultFormElementVariant
} from '../types/FormElement.types';

// Utils
import { eligibleProp } from '../utils/props-utils';

export default {
    name: 'FormElement',
    mixins: [styles],
    props: {
        variant: {
            type: String,
            default: defaultFormElementVariant,
            validator: eligibleProp(formElementVariants)
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            default: '',
        },
    },
    computed: {
        isSelect: function () {
            return this.variant === formElementVariants.select;
        },
        elementClasses: function () {
            return [
                this.cssClasses.pcc__formElement,
                this.isSelect && this.cssClasses.pcc__formElement_select,
                this.invalid && this.cssClasses.pcc__formElement_invalid
            ];
        }
    },
    render: function (createFormElement) {
        return createFormElement(this.variant, { domProps: { value: this.value }, on: { ...this.$listeners }, class: this.elementClasses }, this.$slots.default);
    }
}
</script>
